import { queryServiceByFormId } from './api/query-service-by-form-id';
import { uoUWidgetLoadOnLiveSiteSrc187Evid8 } from '@wix/bi-logger-bookings-data/v2';
export const loadInitialAppointmentData = async (httpClient, errorHandler, formId, _form, environment, bi) => {
  if (environment.isEditor) {
    return {};
  }
  bi == null || bi.report(uoUWidgetLoadOnLiveSiteSrc187Evid8({
    widgetName: 'appointment',
    environment: JSON.stringify(environment)
  }));
  const [service] = await Promise.all([queryServiceByFormId({
    httpClient,
    errorHandler,
    formId
  })]);
  return {
    service
  };
};
//# sourceMappingURL=load-initial-appointment-data.js.map